/* eslint-disable */
import { useMemo } from "react";
import { useDictionary, useOLAPTransformer, OLAPTransformerResult, OLAPTransformerOptions } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Dictionary } from "@sa/rep-mdm";
import { OLAPResult } from "@sa/rep-olap";
import { SLIDE_NUMBER } from "../constants";

const ROW_AXIS = "attributes.default";
const COLUMN_AXIS = "calendar.default";

export function useChartIndexData(olapResult: OLAPResult | null): OLAPTransformerResult | null {
  const [, columnsDict] = useDictionary(dictionaryService, "calendar-origin");

  const options = useMemo<OLAPTransformerOptions | null>(() => {
    if ([olapResult, columnsDict].some(x => !Boolean(x))) {
      return null;
    }

    return {
      data: olapResult?.data,
      attrsDictionaries: new Map([
        [COLUMN_AXIS, columnsDict],
      ]) as ReadonlyMap<string, Dictionary>
    } as OLAPTransformerOptions
  }, [olapResult, columnsDict]);

  const query = useMemo(() => {
    return {
      lcid: 9,
      columns: [`${COLUMN_AXIS}.name`, `${COLUMN_AXIS}.id`],
      rows: [],
      cellData: {
        inCell: ["Measures.value", "Measures.correlation"],
        attributes: [`${COLUMN_AXIS}.name`, `${COLUMN_AXIS}.id`],
      },
    }
  }, []);
  const data = useOLAPTransformer(options, query);
  return data;
}
